var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"range-input",attrs:{"readonly":""},domProps:{"value":_vm.dateTime}})}
var staticRenderFns = []

export { render, staticRenderFns }